import { useEffect, useRef, useState } from "react";
import Barcode from "react-barcode";
import useScanDetection from "use-scan-detection";
import { useGetPageQuery, useLazyGetPageQuery } from "../../../redux/services/crmAPI";

import { Link } from "react-router-dom";
import { filterReportsData, sortReportsData } from "./reportsWebData";

const ReportsWeb = () => {
    const basicBarCode = "00000000";
    const [barCode, setBareCode] = useState();

    const noBaseRef = useRef();
    const noListRef = useRef();
    const listRef = useRef();

    const [notFoundInBase, setNotFounsInBase] = useState([]);
    const [notFoundInList, setNotFounsInList] = useState([]);
    const [reportsList, setReportsList] = useState([]);

    const [activeStore, setActiveStore] = useState("");
    const [activeCategory, setActiveCategory] = useState(0);
    const [activeSort, setActiveSort] = useState(1);

    const [categoriesParams, setCategoriesParams] = useState("");
    const [sortParams, setSortParms] = useState(sortReportsData[0].value);
    const [priceFrom, setPriceFrom] = useState("");
    const [priceTo, setPriceTo] = useState("");

    const sortQweryParams = "&order=" + sortParams;
    const storeParams = activeStore ? "&store_id=" + activeStore : "";
    const priceFromParams = priceFrom !== "" ? "&min_price=" + priceFrom : "";
    const priceToParams = priceTo !== "" ? "&max_price=" + priceTo : "";

    const combinedParams = storeParams + sortQweryParams + categoriesParams + priceFromParams + priceToParams;

    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const { data: reports } = useGetPageQuery("report/web-remainings?order_sort=desc" + combinedParams);
    const [triggerProductsFetch, product] = useLazyGetPageQuery();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setReportsList([...reportsList, e.target.value]);
        } else if (!e.target.checked) {
            setReportsList([...reportsList.filter((id) => id !== e.target.value)]);
        }
    };

    const setCategoryHandler = (id, categories, price) => {
        setActiveCategory(id);
        setCategoriesParams(categories);
        setPriceFrom(price[0]);
        setPriceTo(price[1]);
        setNotFounsInBase([]);
        setNotFounsInList([]);
        setReportsList([]);
    };

    const setSortHandler = (id, value) => {
        setActiveSort(id);
        setSortParms(value);
        setNotFounsInBase([]);
        setNotFounsInList([]);
        setReportsList([]);
    };

    const setStoreHandler = (storeId) => {
        setActiveStore(storeId);
        setNotFounsInBase([]);
        setNotFounsInList([]);
        setReportsList([]);
    };

    useScanDetection({
        onComplete: addScannedValue,
        minLength: 0,
    });

    async function addScannedValue(code) {
        if (reports.some((report) => report.id === parseInt(code, 10))) {
            setBareCode(code);
            setReportsList([...reportsList, parseInt(code, 10).toString()]);
        } else {
            setBareCode(code);
            await triggerProductsFetch("products/" + code);
            if (notFoundInList.length >= 1) {
                noListRef.current.scrollIntoView();
            } else if (notFoundInBase >= 1) {
                noBaseRef.current.scrollIntoView();
            }
        }
    }

    const calculateScannTimes = (idValue) => {
        const counts = {};
        reportsList.forEach(function (x) {
            counts[x] = (counts[x] || 0) + 1;
        });
        return counts[idValue];
    };

    useEffect(() => {
        if (
            product.data &&
            product.error?.status !== 404 &&
            notFoundInList.every((productItem) => productItem.id !== product.data.id)
        ) {
            setNotFounsInList([...notFoundInList, product.data]);
        }

        if (product.error?.status === 404 && notFoundInBase.every((productItem) => productItem !== barCode)) {
            setNotFounsInBase([...notFoundInBase, barCode]);
        }
    }, [product.data, product?.error]);

    useEffect(() => {
        if (reportsList.length > 0 && barCode) {
            listRef.current.scrollIntoView();
        }
    }, [reportsList]);

    useEffect(() => {
        if (notFoundInList.length > 0 && barCode) {
            noListRef.current.scrollIntoView();
        }
    }, [notFoundInList]);

    useEffect(() => {
        if (notFoundInBase.length > 0 && barCode) {
            noBaseRef.current.scrollIntoView();
        }
    }, [notFoundInBase]);

    return (
        <>
            {stores && reports && (
                <div className="content">
                    <div className="col-12">
                        <div
                            id="page-header"
                            className="no-print"
                        >
                            <h1>Залишки товарів Web</h1>
                        </div>
                        <script src="assets/js/JsBarcode.all.min.js"></script>
                        <div className="row">
                            <div className="col-12">
                                <div className="no-print">
                                    {stores.data.map((store) => {
                                        return (
                                            <div
                                                key={store.id}
                                                className={
                                                    activeStore === store.id
                                                        ? "btn btn-info no-print mx-1"
                                                        : "btn btn-primary no-print mx-1"
                                                }
                                                onClick={() => setStoreHandler(store.id)}
                                                style={{ marginBottom: "5px" }}
                                            >
                                                {store.title}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="no-print margin20">
                                    {filterReportsData.map((filter) => {
                                        return (
                                            <div
                                                key={filter.id}
                                                className={
                                                    activeCategory === filter.id
                                                        ? "btn btn-info no-print mx-1"
                                                        : "btn btn-primary no-print mx-1"
                                                }
                                                style={{ marginBottom: "5px" }}
                                                onClick={() =>
                                                    setCategoryHandler(filter.id, filter.categories, filter.price)
                                                }
                                            >
                                                {filter.title}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="no-print margin20">
                                    {sortReportsData.map((sort) => {
                                        return (
                                            <div
                                                key={sort.id}
                                                className={
                                                    activeSort === sort.id
                                                        ? "btn btn-info  mx-1"
                                                        : "btn btn-primary mx-1"
                                                }
                                                style={{ marginBottom: "5px" }}
                                                onClick={() => setSortHandler(sort.id, sort.value)}
                                            >
                                                {sort.title}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="found_products">
                                <h2>Товари на складі ({reports.length})</h2>
                                <a
                                    className="check_all no-print"
                                    href="#"
                                >
                                    Показати тільки не відмічені
                                </a>
                                {reports.length === 0 ? (
                                    <div className="alert alert-warning margin20">Товари відсутні</div>
                                ) : (
                                    <table className="table striped table-print">
                                        <thead className="no-print">
                                            <tr>
                                                <th
                                                    data-field="user_status"
                                                    className="check_area"
                                                ></th>
                                                <th data-field="user_status">ID</th>
                                                <th data-field="user_status">Назва</th>
                                                <th
                                                    data-field="user_status"
                                                    className="no-mobile"
                                                >
                                                    IMEI
                                                </th>
                                                <th
                                                    data-field="user_status"
                                                    className="no-mobile"
                                                >
                                                    Ціна
                                                </th>
                                                <th
                                                    data-field="user_status"
                                                    className="no-mobile"
                                                >
                                                    Скановано
                                                </th>
                                                <th
                                                    data-field="user_status"
                                                    className="no-mobile"
                                                >
                                                    На складі
                                                </th>
                                                <th data-field="user_status">BarCode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reports.map((report) => {
                                                return (
                                                    <tr
                                                        ref={parseInt(barCode, 10) === report.id ? listRef : null}
                                                        className={`${
                                                            +calculateScannTimes(report.id.toString()) >= 2
                                                                ? "table-danger"
                                                                : "" || +calculateScannTimes(report.id.toString()) === 1
                                                                ? "table-success"
                                                                : ""
                                                        } ${reportsList.includes(report.id + "") ? " no-print" : ""}`}
                                                        key={report.id}
                                                    >
                                                        <td className="check_area text-right">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={reportsList.includes(report.id.toString())}
                                                                    onChange={(e) => listCheckHandler(e)}
                                                                    value={report.id}
                                                                />
                                                                <label className="custom-control-label">&nbsp;</label>
                                                            </div>
                                                        </td>
                                                        <td>#{report.id}</td>
                                                        <td>
                                                            <Link
                                                                to={"/product/" + report.id}
                                                                data-callmodal="product_info"
                                                                data-params='{"product_id":63421}'
                                                                data-id="63421"
                                                            >
                                                                {report.title}
                                                            </Link>
                                                        </td>
                                                        <td className="no-mobile">{report.imei_sn}</td>
                                                        <td className="no-mobile">{report.price}&nbsp;грн</td>
                                                        <td className="no-mobile scanned">
                                                            {calculateScannTimes(report.id.toString()) || "0"}
                                                        </td>
                                                        <td className="no-mobile">{report.quantity}</td>
                                                        <td>
                                                            <Barcode
                                                                width={1.5}
                                                                margin={1}
                                                                height={20}
                                                                displayValue={false}
                                                                value={basicBarCode.slice(report.id.length) + report.id}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            {notFoundInList.length !== 0 && (
                                <div className="not_found">
                                    <h2 ref={noListRef}>Відсутні у списку товари</h2>

                                    <table className="table striped table-print">
                                        <thead className="no-print">
                                            <tr>
                                                <th data-field="user_status">Магазин</th>
                                                <th data-field="user_status">Назва</th>
                                                <th data-field="user_status">IMEI</th>
                                                <th data-field="user_status">Ціна</th>
                                                <th data-field="user_status">Залишок</th>
                                                <th data-field="user_status">Проскановано</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notFoundInList.map((product) => {
                                                return (
                                                    <tr
                                                        id="check_p71883"
                                                        key={product.id}
                                                    >
                                                        <td>{product.store.title}</td>
                                                        <td>
                                                            <Link to={"/product/" + product.id}>{product.title}</Link>
                                                        </td>
                                                        <td></td>
                                                        <td>{product.price}</td>
                                                        <td>{product.quantity}</td>
                                                        <td>{product.id}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            {notFoundInBase.length !== 0 && (
                                <div className="not_database">
                                    <h2 ref={noBaseRef}>Не знайдено в базі</h2>

                                    <table className="table striped table-print">
                                        <thead className="no-print">
                                            <tr>
                                                <th data-field="user_status">ID товару</th>
                                                <th data-field="user_status">Проскановано</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notFoundInBase.map((product, index) => {
                                                return (
                                                    <tr
                                                        id="check_p13"
                                                        key={product + index}
                                                    >
                                                        <td>{product}</td>
                                                        <td>{product}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            <div className="no-print">
                                <button
                                    className="btn btn-primary pull-right no-print float-start"
                                    onClick={() => window.print()}
                                >
                                    Друк звіту
                                </button>
                            </div>
                            {/* <div className="no-print">
                                <button className="btn btn-primary float__p float-end no-print" id="clear_buffer">
                                    Очистити буфер
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReportsWeb;
